import { useIntl } from 'react-intl'
import TabWrapper from '../../components/TabWrapper/TabWrapper'
import MakeTable from '../Brands/MakeTable'
import { AssetTable } from './AssetTable'
import { messages } from './messages'

const Assets = () => {
    const { formatMessage } = useIntl()
    const tabs = [
        {
            label: formatMessage(messages.title),
            content: <AssetTable />
        },
        {
            label: formatMessage(messages.makesTableTitle),
            content: <MakeTable />
        }
    ]
    return (
        <TabWrapper tabs={tabs} />
    )
}

export default Assets